import { createClient } from '@supabase/supabase-js';

// NOTE: `import.meta.env` can be flagged by `tsc --noEmit` if vite/client types are not loaded.
// This is a known pre-existing warning and does not affect the production Vite build.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const safeParseJSON = <T>(raw: string | null, fallback: T): T => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch (error) {
    console.warn('R MAX: Invalid localStorage JSON detected, resetting fallback.', error, raw);
    return fallback;
  }
};

// Mock client for local storage fallback
const createLocalStorageMock = () => {
  console.log('R MAX: Usando LocalStorage Fallback (Modo Offline/Simulação)');
  return {
    from: (table: string) => ({
      select: () => ({
        eq: () => {
          const resultData = safeParseJSON<any[]>(localStorage.getItem(`rmax_${table}`), []).map((item: any) => ({
            ...item,
            total_value: Number(item.total_value) || 0,
            price: Number(item.price) || 0
          }));
          const result = {
            data: resultData,
            error: null,
            maybeSingle: () => ({ data: resultData.length > 0 ? resultData[0] : null, error: null })
          };
          return result;
        },
        data: safeParseJSON<any[]>(localStorage.getItem(`rmax_${table}`), []).map((item: any) => ({
          ...item,
          total_value: Number(item.total_value) || 0,
          price: Number(item.price) || 0
        })),
        error: null
      }),
      upsert: (data: any) => {
        const existing = safeParseJSON<any[]>(localStorage.getItem(`rmax_${table}`), []);
        localStorage.setItem(`rmax_${table}`, JSON.stringify([...existing, data]));
        return { data, error: null };
      },
      insert: (data: any) => {
        const existing = safeParseJSON<any[]>(localStorage.getItem(`rmax_${table}`), []);
        localStorage.setItem(`rmax_${table}`, JSON.stringify([...existing, data]));
        return { data, error: null };
      },
      delete: () => ({ eq: () => ({ error: null }) })
    }),
    auth: {
      getSession: async () => ({ data: { session: null }, error: null }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
    }
  } as any;
};

export const supabase = (() => {
  if (import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY) {
    return createClient(supabaseUrl, supabaseAnonKey);
  }
  if (import.meta.env.DEV) {
    return createLocalStorageMock();
  }
  throw new Error("Variáveis de ambiente do Supabase (URL e ANON_KEY) não encontradas em ambiente de produção. Interrompendo execução por segurança.");
})();

// Log de verificação inicial (apenas em desenvolvimento)
if (import.meta.env.DEV) {
  console.log('R MAX: Cliente Supabase inicializado [URL:', supabaseUrl?.substring(0, 15) + '...]');
}
